import React, { useState } from 'react';
import { useSettings } from '../../contexts/SettingsContext';
import { validateResolution } from '../../utils/imageCompression';

function CustomProfileForm() {
  const { settings, updateCustomProfile, setActiveProfile } = useSettings();
  const [width, setWidth] = useState(settings.compression.customProfile.resolution.width);
  const [height, setHeight] = useState(settings.compression.customProfile.resolution.height);
  const [quality, setQuality] = useState(settings.compression.customProfile.quality);
  const [error, setError] = useState('');
  const [expanded, setExpanded] = useState(false);

  const handleSave = () => {
    // Validate resolution
    const validation = validateResolution(parseInt(width), parseInt(height));
    
    if (!validation.valid) {
      setError(validation.error);
      return;
    }

    // Clear error and save
    setError('');
    updateCustomProfile({
      resolution: { width: parseInt(width), height: parseInt(height) },
      quality: parseFloat(quality),
    });

    // Switch to custom profile
    setActiveProfile('custom');

    console.log('[CustomProfileForm] Custom profile saved:', {
      width: parseInt(width),
      height: parseInt(height),
      quality: parseFloat(quality),
    });
  };

  const handleReset = () => {
    setWidth(1920);
    setHeight(1080);
    setQuality(0.85);
    setError('');
  };

  return (
    <div className="custom-profile-section">
      <h4 className="compression-section-title" style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }} onClick={() => setExpanded(!expanded)}>
        <span>{expanded ? '▼' : '▶'}</span>
        Custom Profile
      </h4>

      {expanded && (
        <div className="custom-profile-form">
          <div className="form-group">
            <label className="form-label">Resolution</label>
            <div className="form-input-group">
              <input
                type="number"
                className="form-input"
                value={width}
                onChange={(e) => setWidth(e.target.value)}
                min="640"
                max="3840"
                placeholder="Width"
              />
              <span className="form-input-separator">×</span>
              <input
                type="number"
                className="form-input"
                value={height}
                onChange={(e) => setHeight(e.target.value)}
                min="360"
                max="2160"
                placeholder="Height"
              />
            </div>
            <small style={{ color: '#8899a6', fontSize: '12px', marginTop: '4px', display: 'block' }}>
              Min: 640×360 | Max: 3840×2160 (4K)
            </small>
          </div>

          <div className="form-group">
            <label className="form-label">Quality: {Math.round(quality * 100)}%</label>
            <div className="quality-slider">
              <input
                type="range"
                min="0.5"
                max="1.0"
                step="0.05"
                value={quality}
                onChange={(e) => setQuality(parseFloat(e.target.value))}
              />
            </div>
            <small style={{ color: '#8899a6', fontSize: '12px', marginTop: '4px', display: 'block' }}>
              Lower quality = smaller files, faster uploads
            </small>
          </div>

          {error && (
            <div style={{ 
              padding: '12px', 
              backgroundColor: 'rgba(255, 107, 107, 0.1)', 
              border: '1px solid #ff6b6b',
              borderRadius: '6px',
              color: '#ff6b6b',
              fontSize: '14px',
              marginBottom: '12px'
            }}>
              {error}
            </div>
          )}

          <div className="profile-actions">
            <button className="btn btn-primary" onClick={handleSave}>
              Save Custom Profile
            </button>
            <button className="btn btn-secondary" onClick={handleReset}>
              Reset to Defaults
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default CustomProfileForm;

